// OneService.js (Redesigned Round Card Version)
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { IoMdArrowForward } from "react-icons/io";

export default function OneService({ image, title, description, navToLink = {} }) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  return (
    <div
      data-aos="fade-right"
      className="col-md-6 p-3 d-flex justify-content-center"
      style={{ cursor: "pointer" }}
      onClick={() => appContext.navTo(navToLink)}
    >
      <div
        className="rounded-4 shadow-sm p-4 bg-white text-center"
        style={{ width: "100%", maxWidth: "380px" }}
      >
        <div
          className="rounded mx-auto mb-3 shadow-sm"
          style={{
            width: "100%",
            height: "200px",
            backgroundImage: `url(${image})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        ></div>

        <div className="bg-light rounded-4 p-3">
          <h5 className="font-bold text-secondary mb-3">{title}</h5>
          <p className="mb-3" style={{ fontSize: "0.9rem" }}>
            {description}
          </p>

          <button className="btn btn-primary rounded-pill d-flex align-items-center gap-3 mx-auto mt-3">
            Learn More <IoMdArrowForward size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
